module.exports = __webpack_public_path__ + "static/media/normalFlowExample.98d7c27a.png";